import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { BaseApiResponse } from 'app/core/models/api/api.model';
import { Symptom } from 'app/core/models/symptom/symptom.model';
import { environment } from '../../../../environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SymptomService {
  constructor(private apiService: ApiService) {}

  async getListSymptom(): Promise<BaseApiResponse<Symptom[]>> {
    return await firstValueFrom(
      this.apiService.get<Symptom[]>(
        `${environment.apiLocations.patient}/symptom`,
      ),
    );
  }
}
